import React from "react";
import {
  LegalPage,
  LegalSection,
  LegalList,
  LegalMail,
  LegalLink,
} from "../components/Legal";

const DSB = {
  de: (
    <>
      Österreichische Datenschutzbehörde, Barichgasse 40–42, 1030 Wien,{" "}
      <LegalMail>dsb@dsb.gv.at</LegalMail>,{" "}
      <LegalLink href="https://www.dsb.gv.at">www.dsb.gv.at</LegalLink>
    </>
  ),
  es: (
    <>
      Autoridad Austriaca de Protección de Datos (Österreichische
      Datenschutzbehörde), Barichgasse 40–42, 1030 Viena,{" "}
      <LegalMail>dsb@dsb.gv.at</LegalMail>,{" "}
      <LegalLink href="https://www.dsb.gv.at">www.dsb.gv.at</LegalLink>
    </>
  ),
};

export default function Privacy({ language = "de" }) {
  const de = language === "de";

  return (
    <LegalPage
      title={de ? "Datenschutzerklärung" : "Política de privacidad"}
      subtitle={
        de
          ? "Information über die Verarbeitung personenbezogener Daten auf dieser Website gemäß Art. 13 und 14 DSGVO."
          : "Información sobre el tratamiento de datos personales en este sitio web conforme a los artículos 13 y 14 del RGPD."
      }
      updated={de ? "Stand: September 2026" : "Actualizada en septiembre de 2026"}
    >
      <LegalSection
        title={de ? "In einem Satz" : "En una frase"}
      >
        <p>
          {de
            ? "Diese Website setzt keine Analyse- oder Werbedienste ein, bindet keine externen Schriften ein und erstellt keine Profile. Personenbezogene Daten verarbeiten wir nur, wenn Sie uns schreiben, und nur, um Ihnen zu antworten."
            : "Este sitio no utiliza servicios de análisis ni de publicidad, no carga fuentes externas y no elabora perfiles. Solo tratamos datos personales cuando usted nos escribe, y únicamente para responderle."}
        </p>
      </LegalSection>

      <LegalSection
        title={de ? "1. Verantwortlicher" : "1. Responsable del tratamiento"}
      >
        <p>
          Blauer Wolf Verlag — César&nbsp;J. Cárdenas&nbsp;Lara
          <br />
          Ober-Pabneukirchen 17, 4363 Pabneukirchen, {de ? "Österreich" : "Austria"}
          <br />
          <LegalMail />
        </p>
        <p>
          {de
            ? "Ein Datenschutzbeauftragter ist gesetzlich nicht erforderlich und wurde nicht bestellt. Anfragen zum Datenschutz richten Sie bitte an die oben genannte E-Mail-Adresse."
            : "No es legalmente exigible designar un delegado de protección de datos y no se ha designado. Las consultas sobre protección de datos pueden dirigirse a la dirección de correo indicada arriba."}
        </p>
      </LegalSection>

      <LegalSection
        title={de ? "2. Hosting und Server-Logfiles" : "2. Alojamiento y registros del servidor"}
      >
        <p>
          {de
            ? "Die Website wird bei der Vercel Inc. (USA) betrieben. Bei jedem Aufruf werden technische Daten verarbeitet, die Ihr Browser automatisch übermittelt:"
            : "El sitio está alojado en Vercel Inc. (EE. UU.). En cada visita se tratan los datos técnicos que su navegador transmite automáticamente:"}
        </p>
        <LegalList
          items={
            de
              ? [
                  "IP-Adresse des anfragenden Geräts",
                  "Datum und Uhrzeit des Zugriffs",
                  "aufgerufene Adresse und übertragene Datenmenge",
                  "Browsertyp, Betriebssystem und, sofern übermittelt, die verweisende Seite",
                ]
              : [
                  "dirección IP del dispositivo",
                  "fecha y hora del acceso",
                  "dirección solicitada y volumen de datos transferido",
                  "tipo de navegador, sistema operativo y, si se transmite, la página de procedencia",
                ]
          }
        />
        <p>
          {de
            ? "Zweck ist die technische Bereitstellung und die Abwehr von Angriffen; Rechtsgrundlage ist unser berechtigtes Interesse an einem sicheren Betrieb (Art. 6 Abs. 1 lit. f DSGVO). Diese Daten werden nicht mit anderen Quellen zusammengeführt und nach kurzer Zeit automatisch gelöscht."
            : "La finalidad es la prestación técnica del servicio y la defensa frente a ataques; la base jurídica es nuestro interés legítimo en un funcionamiento seguro (art. 6.1.f RGPD). Estos datos no se combinan con otras fuentes y se eliminan automáticamente al poco tiempo."}
        </p>
        <p>
          {de
            ? "Mit Vercel besteht ein Auftragsverarbeitungsvertrag. Vercel Inc. ist unter dem EU-US Data Privacy Framework zertifiziert; ergänzend gelten die Standardvertragsklauseln der Europäischen Kommission."
            : "Con Vercel existe un contrato de encargado del tratamiento. Vercel Inc. está certificada en el marco EU-US Data Privacy Framework y, de forma complementaria, se aplican las cláusulas contractuales tipo de la Comisión Europea."}
        </p>
      </LegalSection>

      <LegalSection
        title={de ? "3. Kontaktformular und E-Mail" : "3. Formulario de contacto y correo electrónico"}
      >
        <p>
          {de
            ? "Wenn Sie das Formular benutzen, verarbeiten wir die von Ihnen eingegebenen Angaben: Name, E-Mail-Adresse, Ihre Nachricht und, falls Sie eines anhängen, die hochgeladene Datei. Die Nachricht wird an unser Postfach weitergeleitet; sie wird nicht in einer Datenbank auf der Website gespeichert."
            : "Si utiliza el formulario, tratamos los datos que introduzca: nombre, dirección de correo electrónico, su mensaje y, si adjunta uno, el archivo que suba. El mensaje se remite a nuestro buzón; no se almacena en ninguna base de datos del sitio web."}
        </p>
        <p>
          {de
            ? "Zweck ist ausschließlich die Bearbeitung und Beantwortung Ihrer Anfrage. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, wenn Ihre Anfrage auf einen Vertrag gerichtet ist, sonst Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Kommunikation mit Interessenten). Die Angabe von Name, E-Mail und Nachricht ist erforderlich, um antworten zu können; der Dateianhang ist freiwillig."
            : "La finalidad es exclusivamente tramitar y responder a su consulta. La base jurídica es el art. 6.1.b RGPD cuando su consulta se dirige a la celebración de un contrato y, en los demás casos, el art. 6.1.f RGPD (interés legítimo en comunicarnos con quien nos escribe). El nombre, el correo y el mensaje son necesarios para poder responder; el archivo adjunto es voluntario."}
        </p>
        <p>
          {de
            ? "Wir löschen die Korrespondenz, sobald sie abgeschlossen ist und keine Aufbewahrungspflicht besteht. Entsteht daraus eine geschäftliche Beziehung, gelten die gesetzlichen Aufbewahrungsfristen (insbesondere sieben Jahre gemäß § 132 BAO)."
            : "Eliminamos la correspondencia una vez concluida, salvo que exista un deber legal de conservación. Si de ella nace una relación comercial, se aplican los plazos legales de conservación (en particular, siete años conforme al § 132 BAO austriaco)."}
        </p>
        <p>
          {de
            ? "Für den Versand der Formularnachricht nutzen wir den E-Mail-Server unseres Providers (1&1 IONOS SE, Deutschland). Wenn Sie uns direkt per E-Mail schreiben, gilt dasselbe für Ihre Nachricht."
            : "Para el envío del mensaje del formulario utilizamos el servidor de correo de nuestro proveedor (1&1 IONOS SE, Alemania). Lo mismo se aplica a su mensaje si nos escribe directamente por correo electrónico."}
        </p>
      </LegalSection>

      <LegalSection
        title={de ? "4. Eingesandte Manuskripte" : "4. Manuscritos enviados"}
      >
        <p>
          {de
            ? "Manuskripte und Textproben, die Sie uns schicken, lesen wir nur, um Ihre Anfrage einzuschätzen. Das Urheberrecht bleibt selbstverständlich bei Ihnen. Wir geben Ihren Text nicht an Dritte weiter und löschen ihn, wenn es zu keiner Zusammenarbeit kommt oder wenn Sie es verlangen."
            : "Los manuscritos y muestras de texto que nos envíe se leen únicamente para valorar su consulta. Los derechos de autor siguen siendo suyos. No cedemos su texto a terceros y lo eliminamos si no llegamos a colaborar o si usted así lo pide."}
        </p>
      </LegalSection>

      <LegalSection
        title={de ? "5. Spamschutz: Cloudflare Turnstile" : "5. Protección antispam: Cloudflare Turnstile"}
      >
        <p>
          {de
            ? "Das Kontaktformular ist mit Cloudflare Turnstile gegen automatisierte Zusendungen geschützt. Dieser Dienst wird ausschließlich auf der Seite mit dem Formular geladen — nicht auf den übrigen Seiten dieser Website."
            : "El formulario de contacto está protegido contra envíos automatizados con Cloudflare Turnstile. Este servicio se carga únicamente en la página que contiene el formulario, no en el resto del sitio."}
        </p>
        <p>
          {de
            ? "Dabei werden Ihre IP-Adresse sowie Angaben zu Browser und Gerät an die Cloudflare Inc. (USA) übermittelt, um zu prüfen, ob die Anfrage von einem Menschen stammt. Turnstile verwendet nach Angaben des Anbieters keine Cookies zu Werbezwecken und erstellt keine Profile. Rechtsgrundlage ist unser berechtigtes Interesse am Schutz vor Missbrauch (Art. 6 Abs. 1 lit. f DSGVO)."
            : "En ese proceso se transmiten su dirección IP y datos sobre el navegador y el dispositivo a Cloudflare Inc. (EE. UU.) para comprobar que la solicitud procede de una persona. Según el proveedor, Turnstile no emplea cookies con fines publicitarios ni elabora perfiles. La base jurídica es nuestro interés legítimo en protegernos frente a abusos (art. 6.1.f RGPD)."}
        </p>
        <p>
          {de
            ? "Cloudflare Inc. ist unter dem EU-US Data Privacy Framework zertifiziert und stützt Übermittlungen zusätzlich auf die Standardvertragsklauseln. Einzelheiten: "
            : "Cloudflare Inc. está certificada en el marco EU-US Data Privacy Framework y basa además las transferencias en las cláusulas contractuales tipo. Detalles: "}
          <LegalLink href="https://www.cloudflare.com/privacypolicy/">
            cloudflare.com/privacypolicy
          </LegalLink>
          .
        </p>
      </LegalSection>

      <LegalSection
        title={de ? "6. Schriften" : "6. Tipografías"}
      >
        <p>
          {de
            ? "Alle Schriften dieser Website liegen auf unserem eigenen Server. Es werden keine Google Fonts oder andere externe Schriftdienste eingebunden; beim Laden der Seite entsteht dadurch keine Verbindung zu Dritten."
            : "Todas las tipografías de este sitio se sirven desde nuestro propio servidor. No se incrusta Google Fonts ni ningún otro servicio externo de fuentes, de modo que al cargar la página no se establece conexión alguna con terceros."}
        </p>
      </LegalSection>

      <LegalSection
        title={de ? "7. Cookies und lokaler Speicher" : "7. Cookies y almacenamiento local"}
      >
        <p>
          {de
            ? "Wir setzen keine Analyse-, Werbe- oder Tracking-Cookies. Gespeichert wird allein ein Eintrag im lokalen Speicher Ihres Browsers («cookie-consent»), der sich merkt, dass Sie den Hinweis unten gelesen haben, damit er nicht bei jedem Besuch erscheint. Dieser Eintrag enthält keine personenbezogenen Daten, verlässt Ihr Gerät nicht und kann von Ihnen jederzeit über die Einstellungen Ihres Browsers gelöscht werden."
            : "No utilizamos cookies de análisis, publicidad ni seguimiento. Lo único que se guarda es una entrada en el almacenamiento local de su navegador («cookie-consent») que recuerda que ya ha leído el aviso inferior, para no mostrarlo en cada visita. Esa entrada no contiene datos personales, no sale de su dispositivo y puede borrarla en cualquier momento desde la configuración del navegador."}
        </p>
        <p>
          {de
            ? "Mehr dazu auf der Seite «Cookies»."
            : "Más detalles en la página «Cookies»."}
        </p>
      </LegalSection>

      <LegalSection
        title={
          de
            ? "8. Weitergabe, Profilbildung, automatisierte Entscheidungen"
            : "8. Cesiones, elaboración de perfiles y decisiones automatizadas"
        }
      >
        <p>
          {de
            ? "Wir verkaufen keine Daten und geben sie nicht zu Werbezwecken weiter. Eine Übermittlung erfolgt nur an die oben genannten Auftragsverarbeiter (Hosting, E-Mail, Spamschutz) oder wenn wir gesetzlich dazu verpflichtet sind. Es findet keine Profilbildung und keine automatisierte Entscheidungsfindung im Sinne des Art. 22 DSGVO statt."
            : "No vendemos datos ni los cedemos con fines publicitarios. Solo se comunican a los encargados del tratamiento mencionados (alojamiento, correo, antispam) o cuando exista obligación legal. No se elaboran perfiles ni se toman decisiones automatizadas en el sentido del art. 22 RGPD."}
        </p>
      </LegalSection>

      <LegalSection title={de ? "9. Ihre Rechte" : "9. Sus derechos"}>
        <p>
          {de
            ? "Sie haben uns gegenüber jederzeit folgende Rechte:"
            : "Frente a nosotros usted puede ejercer en cualquier momento los siguientes derechos:"}
        </p>
        <LegalList
          items={
            de
              ? [
                  "Auskunft über die zu Ihrer Person gespeicherten Daten (Art. 15)",
                  "Berichtigung unrichtiger Daten (Art. 16)",
                  "Löschung (Art. 17) und Einschränkung der Verarbeitung (Art. 18)",
                  "Datenübertragbarkeit (Art. 20)",
                  "Widerspruch gegen Verarbeitungen, die auf berechtigtem Interesse beruhen (Art. 21)",
                  "Widerruf einer erteilten Einwilligung mit Wirkung für die Zukunft (Art. 7 Abs. 3)",
                ]
              : [
                  "acceso a los datos que conservamos sobre usted (art. 15)",
                  "rectificación de datos inexactos (art. 16)",
                  "supresión (art. 17) y limitación del tratamiento (art. 18)",
                  "portabilidad de los datos (art. 20)",
                  "oposición a los tratamientos basados en el interés legítimo (art. 21)",
                  "retirada del consentimiento prestado, con efectos para el futuro (art. 7.3)",
                ]
          }
        />
        <p>
          {de
            ? "Eine E-Mail an "
            : "Basta un correo a "}
          <LegalMail />
          {de
            ? " genügt. Wir antworten innerhalb eines Monats."
            : ". Respondemos en el plazo de un mes."}
        </p>
      </LegalSection>

      <LegalSection
        title={de ? "10. Beschwerderecht" : "10. Derecho a reclamar"}
      >
        <p>
          {de
            ? "Wenn Sie der Ansicht sind, dass wir Ihre Daten nicht rechtmäßig verarbeiten, können Sie sich bei der Aufsichtsbehörde beschweren: "
            : "Si considera que no tratamos sus datos conforme a la ley, puede presentar una reclamación ante la autoridad de control: "}
          {DSB[language]}.
        </p>
      </LegalSection>

      <LegalSection
        title={de ? "11. Änderungen" : "11. Cambios en esta política"}
      >
        <p>
          {de
            ? "Ändern sich die Dienste oder die Rechtslage, passen wir diese Erklärung an. Es gilt jeweils die hier veröffentlichte Fassung; das Datum oben zeigt den Stand."
            : "Si cambian los servicios que utilizamos o la normativa aplicable, actualizaremos esta declaración. Rige siempre la versión publicada en esta página; la fecha superior indica su estado."}
        </p>
      </LegalSection>
    </LegalPage>
  );
}
